<template>
    <div :class="['patent-view__side-function--compare', isCollapsed ? 'patent-view__side-function--collapse' : 'patent-view__side-function--expand']">
        <!--展开态-->
        <div v-show="!isCollapsed" class="patent-view__side-function-container--expand">
            <!--tabs-->
            <PtTabs
                v-model="currentTab"
                :config="rightColumnTabConfig"
                activeColor="#fff"
                class="patent-view__side-function__tab"
            >
                <template #default="{ context }">
                    <div class="patent-view__side-function__tab-item">
                        <PtIcon
                            :icon="context.icon"
                            class="patent-view__side-function__tab-icon"
                            :class="{
                                '!pa-text-gray-55': context.disabled
                            }"
                        />
                        <span
                            class="patent-view__side-function__tab-text"
                            :class="{
                                '!pa-text-gray-55': context.disabled
                            }"
                        >
                            {{ context.label }}
                        </span>
                    </div>
                </template>
            </PtTabs>
            <!--content-->
            <div class="patent-view__side-function-main-content">
                <!-- compare list -->
                <ComparePatentList
                    v-if="hasPatentList"
                    v-show="currentTab === 'patentList'"
                />
                <!-- compare result -->
                <CompareResultList v-show="currentTab === 'compare'" />
            </div>
        </div>
        <!--收缩态-->
        <div v-show="isCollapsed" class="patent-view__side-function-container--collapse">
            <div class="patent-view__side-function-collapse-icon-group">
                <ElTooltip
                    v-for="item in rightColumnTabConfig"
                    :key="item.action"
                    :visibleArrow="false"
                    :content="$t(item.tooltip)"
                    :disabled="!item.tooltip"
                    :openDelay="POPPER_OPEN_DELAY"
                    placement="left"
                >
                    <div class="patent-view__side-function-collapse-icon" @click="expandAndToggleTab(item.action)">
                        <PtIcon :icon="item.icon" />
                    </div>
                </ElTooltip>
            </div>
            <DataReport class="patent-view__side-function-collapse-report" />
        </div>
        <!--快捷键-->
        <Toggle
            :isCollapsed="isCollapsed"
            @toggle="toggleClicked"
        />
    </div>
</template>

<script>
import $ from 'jquery';
import { Icon, Toast } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/Menu4.svg';
import '@patsnap-ui/icon/assets/solid/compareView.svg';
import '@patsnap-ui/icon/assets/solid/HighlightPen.svg';
import '@patsnap-ui/icon/assets/solid/chat.svg';
import { Tooltip } from 'element-ui';
import PtTabs from '@/components/PtTabs';
import DataReport from '../../components/data-report/DataReport';
import Toggle from './patents-list/Toggle';
import { POPPER_OPEN_DELAY } from '../../constants';
import ComparePatentList from '@/components/compare-components/compare-patent-list/ComparePatentList.vue';
import CompareResultList from '@/components/compare-components/compare-result-list/CompareResultList.vue';
import { useCompareUrlState } from '@/composables/use-compare-url-state';
import { useCompareInit } from '@/composables/use-compare-init';
import { usePatentsList } from '@/views/side-function-bar/patents-list/composables/use-patents-list';

const PATENT_LIST_ACTION = 'patentList';
const COMPARE_ACTION = 'compare';

export default {
    name: 'SideFunctionBarCompare',
    components: {
        ComparePatentList,
        CompareResultList,
        Toggle,
        PtTabs,
        DataReport,
        PtIcon: Icon,
        ElTooltip: Tooltip,
    },
    props: {
        viewParams: {
            type: Object,
            required: true,
        },
        patentId: {
            type: Array,
            required: true,
        },
        isCollapsed: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { isSourceCustom, prevCompareMode } = useCompareUrlState();
        const { isStartInit, isNodata } = useCompareInit();
        const { isShowPatentList, setPatentListVisible } = usePatentsList();

        return {
            isSourceCustom,
            prevCompareMode,
            isStartInit,
            isCompareNodata: isNodata,
            isShowPatentList,
            setPatentListVisible,
        };
    },
    data() {
        return {
            currentTab: PATENT_LIST_ACTION,
        };
    },
    computed: {
        compareResultListDisabled() {
            return this.isSourceCustom || !this.prevCompareMode;
        },
        rightColumnTabConfig() {
            const tabList = [
                {
                    icon: 'SolidMenu4',
                    action: PATENT_LIST_ACTION,
                    label: this.$t('patent-view.patentList'),
                    hasPermission: true,
                    tooltip: this.$t('patent-view.patentList'),
                },
                {
                    icon: 'SolidCompareView',
                    action: COMPARE_ACTION,
                    label: this.$t('patent-view.compareView.compareResult'),
                    hasPermission: true,
                    tooltip: this.$t('patent-view.compareView.compareResult'),
                    disabled: this.compareResultListDisabled,
                },
            ];
            return tabList.filter(item => item.hasPermission);
        },
        hasPatentList() {
            try {
                return window.location.search.split('$')[0].indexOf('page=') > -1;
            } catch (error) {
                return false;
            }
        },
    },
    watch: {
        isStartInit() {
            if (this.isStartInit) return;
            if (this.isCompareNodata) {
                Toast({
                    type: 'warning',
                    message: this.$t('patent-view.compareView.noFindSimilar'),
                    showClose: true,
                });
            } else {
                this.currentTab = COMPARE_ACTION;
            }
        },
    },
    created() {
        this.POPPER_OPEN_DELAY = POPPER_OPEN_DELAY;
    },
    mounted() {
        // 设置默认选中
        this.setDefaultTab();
    },
    methods: {
        toggleCollapse() {
            window.rvTrack('Click Toggle Button', { source: this.$route.path, type: this.isShowPatentList === false ? 'close-to-open' : 'open-to-close' });
            this.setPatentListVisible(!this.isShowPatentList);
            this.$nextTick(() => $(window).trigger('resize'));
        },
        toggleClicked(type) {
            if (type === 'collapes') this.toggleCollapse();
            // 手动触发resize以便于对比相似段落tag的重新定位
            window.dispatchEvent(new Event('resize'));
        },
        expandAndToggleTab(type) {
            this.currentTab = type;
            this.toggleCollapse();
        },
        setDefaultTab() {
            // 如果是srp勾选跳转过来，不能直接做对比，因此显示patentList
            this.currentTab = this.isSourceCustom ? PATENT_LIST_ACTION : COMPARE_ACTION;
            this.setPatentListVisible(true);
        },
    },
};
</script>

<style lang="scss">
.patent-view__side-function--compare {
    height: 100%;
    width: 100%;

    .patent-view__side-function-container--expand, .patent-view__side-function-container--collapse {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .patent-view__side-function-container--collapse {
        justify-content: space-between;
        padding: 4px 4px 16px 4px;
    }

    .patent-view__side-function__tab {
        background-color: #f4f5f7;
        padding-top: 8px;
        border: 1px solid transparent;
        .pt__tab-item {
            min-width: 0;
            padding: 0 8px;
            margin-right: 0;
            background-color: #f4f5f7;
            border: 1px solid transparent;
            &--active {
                border-color: transparent !important;
            }
            &:first-of-type {
                margin-left: 8px;
            }
            &:last-of-type {
                margin-right: 8px;
            }
        }
        .patent-view__side-function__tab-item {
            line-height: 30px;
        }
        .patent-view__side-function__tab-icon {
            vertical-align: middle;
            font-size: 20px;
        }
        .patent-view__side-function__tab-text {
            display: inline-block;
            vertical-align: middle;
            font-size: 12px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .patent-view__side-function__tab-count {
            color: #5E6C84;
            font-size: 12px;
        }
    }

    .patent-view__side-function-main-content {
        flex: 1;
        overflow: auto;
    }

    .patent-view__side-function-collapse-icon {
        text-align: center;
        border-radius: 2px;
        cursor: pointer;
        padding: 4px;
        margin-bottom: 8px;
        &:last-of-type {
            margin-bottom: 0;
        }
        &:hover {
            background-color: #ebecf0;
        }
    }

    .patent-view__side-function-collapse-report {
        .elstc-btn {
            text-align: center;
            border-radius: 2px;
            width: 32px;
            padding: 4px;
        }
        .eb-pre-text {
            display: none;
        }
    }

    &--collapse {
        background-color: #f4f5f7;
        .patent-list-toggle__item, .patent-list-toggle__item--disabled {
            background-color: #f4f5f7 !important;
        }
    }

    // 对比视图特殊样式
    .patent-view__side-function__comment-container {
        height: 100%;
        .patent-view__side-function__comment-container-title {
            font-size: 14px;
            font-weight: bold;
            line-height: 24px;
            padding: 8px 16px 0 16px;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &.left {
                color: $green-text;
            }
            &.right {
                color: $status-blue-primary;
            }
        }
        .patent-view__side-function__comment-container-inner {
            height: 50%;
            border-bottom: 1px solid #DFE1E6;
            &--full-height {
                height: 100%;
            }
            &:last-of-type {
                border-bottom: none;
            }
        }
        .side-function-bar-comments {
            height: calc(100% - 32px);
            overflow: auto;
        }
    }

    .patent-list-toggle {
        #hot-key-patents-list-previous, #hot-key-patents-list-next {
            display: none;
        }
        #hot-key-patents-list-collapes {
            height: 70px;
            border-radius: 4px 0 0 4px;
            box-shadow: -1px 0px 2px 0px #dfe6ec;
        }
    }

    .new-highlight {
        .new-highlight__body__item {
            .new-highlight__body__item__input {
                width: 100%;
                border-radius: 5px;
            }
            .new-highlight__body__item__pre {
                display: none;
            }
            .new-highlight__body__item__next {
                display: none;
            }
        }
    }
}
</style>
